// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__8GsXQ","disabled":"styles_disabled__5S7G7"};